import { Grid, Typography } from '@mui/material';
import { Alert } from '@piaas/piaas-ui-toolkit/components';

import {
  FormikTextField,
  FormikSelect,
  FormikPasswordField,
  FormikSwitch,
  FormikMultiSelect,
  FormikTextArea,
  FormikUploadFile,
} from '../InputFields/index';

import Tags from '@/components/Tags/Tags';
import ProductUnassignment from '@/pages/OrganizationDetails/Users/ProductUnassignment';

export const FIELD_COMPONENTS: Record<string, React.ElementType> = {
  text: FormikTextField,
  password: FormikPasswordField,
  select: FormikSelect,
  multiSelect: FormikMultiSelect,
  switch: FormikSwitch,
  textArea: FormikTextArea,
  uploadFile: FormikUploadFile,
  productUnassignment: ProductUnassignment,
  inlineNotification: Alert,
  typography: Typography,
  grid: Grid,
  tags: Tags,
};
